import { render, staticRenderFns } from "./PayerView.vue?vue&type=template&id=84a176e2&scoped=true&"
import script from "./PayerView.vue?vue&type=script&lang=js&"
export * from "./PayerView.vue?vue&type=script&lang=js&"
import style0 from "./PayerView.vue?vue&type=style&index=0&id=84a176e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a176e2",
  null
  
)

export default component.exports